export namespace CommonApiUri {
  const BASE_URL = '/lcm/common/api';

  export const OBSOLETE_BINARIES_URL = `${BASE_URL}/obsoletebinaries`;
}
